// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"6c2lz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cameraStream = require("./CameraStream");
parcelHelpers.exportAll(_cameraStream, exports);
var _deviceMotion = require("./DeviceMotion");
parcelHelpers.exportAll(_deviceMotion, exports);
var _deviceOrientation = require("./DeviceOrientation");
parcelHelpers.exportAll(_deviceOrientation, exports);
var _geolocation = require("./Geolocation");
parcelHelpers.exportAll(_geolocation, exports);
var _microphoneStream = require("./MicrophoneStream");
parcelHelpers.exportAll(_microphoneStream, exports);
var _midi = require("./MIDI");
parcelHelpers.exportAll(_midi, exports);
var _screenStream = require("./ScreenStream");
parcelHelpers.exportAll(_screenStream, exports);
var _userMediaStream = require("./UserMediaStream");
parcelHelpers.exportAll(_userMediaStream, exports);

},{"./CameraStream":"lDKlc","./DeviceMotion":"i1va2","./DeviceOrientation":"gFkTP","./Geolocation":"hefei","./MicrophoneStream":"2JS7q","./MIDI":"4BPPy","./ScreenStream":"1cdOU","./UserMediaStream":"hxdzl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lDKlc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A camera feed you can switch between devices.
 *
 * `UserMediaStream` covers acquiring a stream once; this covers living with one
 * — enumerating what is available, cycling to the next camera, and stopping the
 * previous tracks when it does. That last part is the one that bites: calling
 * getUserMedia again without stopping the old tracks leaves the previous camera
 * held open, and on a phone the indicator light stays on.
 *
 * Devices are only enumerable in a useful form after permission is granted —
 * before that, labels come back empty and the list may be incomplete — so
 * enumeration happens after `start`, not before it.
 */ parcelHelpers.export(exports, "CameraStream", ()=>CameraStream);
class CameraStream {
    constructor({ facingMode = "environment", width = 1280, height = 720 } = {}){
        this.stream = null;
        this.devices = [];
        /** A short human-readable name for the active track. */ this.label = "";
        this.deviceIndex = 0;
        this.facingMode = facingMode;
        this.width = width;
        this.height = height;
    }
    /** Whether cycling would reach a different camera. */ get canCycle() {
        return this.devices.length > 1;
    }
    /**
   * Start the camera. Pass a deviceId to open a specific one, otherwise the
   * preferred facing mode decides.
   */ async start(deviceId) {
        this.stop();
        const constraints = deviceId ? {
            video: {
                deviceId: {
                    exact: deviceId
                }
            },
            audio: false
        } : {
            video: {
                facingMode: this.facingMode,
                width: {
                    ideal: this.width
                },
                height: {
                    ideal: this.height
                }
            },
            audio: false
        };
        this.stream = await navigator.mediaDevices.getUserMedia(constraints);
        this.label = this.readLabel();
        await this.refreshDevices();
        if (deviceId) {
            const index = this.devices.findIndex((d)=>d.deviceId === deviceId);
            if (index >= 0) this.deviceIndex = index;
        }
        return this.stream;
    }
    /** Move to the next camera. No-op with fewer than two. */ async cycle() {
        if (!this.canCycle) return this.stream;
        this.deviceIndex = (this.deviceIndex + 1) % this.devices.length;
        return this.start(this.devices[this.deviceIndex].deviceId);
    }
    async refreshDevices() {
        try {
            const all = await navigator.mediaDevices.enumerateDevices();
            this.devices = all.filter((device)=>device.kind === "videoinput");
        } catch  {
            // Enumeration is a convenience; a failure here should not take down a
            // stream that is already running.
            this.devices = [];
        }
        return this.devices;
    }
    stop() {
        if (!this.stream) return;
        for (const track of this.stream.getTracks())track.stop();
        this.stream = null;
    }
    readLabel() {
        const track = this.stream?.getVideoTracks()[0];
        return (track?.label || "camera").slice(0, 28);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i1va2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeviceMovement", ()=>DeviceMovement);
class DeviceMovement {
    constructor({ handler }){
        this.handler = handler;
    }
    async initialize() {
        // @ts-ignore
        if (typeof DeviceMotionEvent.requestPermission === "function") {
            // @ts-ignore
            const permissionState = await DeviceMotionEvent.requestPermission();
            if (permissionState === "granted") window.addEventListener("devicemotion", ({ acceleration, accelerationIncludingGravity, rotationRate, interval })=>{
                this.handler({
                    acceleration,
                    accelerationIncludingGravity,
                    rotationRate,
                    interval
                });
            }, true);
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gFkTP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeviceOrientation", ()=>DeviceOrientation);
class DeviceOrientation {
    constructor({ handler }){
        this.handler = handler;
    }
    async initialize() {
        // @ts-ignore
        if (typeof DeviceOrientationEvent.requestPermission === "function") {
            // @ts-ignore
            const permissionState = await DeviceOrientationEvent.requestPermission();
            if (permissionState === "granted") window.addEventListener("deviceorientation", ({ absolute, alpha, beta, gamma })=>this.handler({
                    absolute,
                    alpha,
                    beta,
                    gamma
                }), true);
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hefei":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Geolocation", ()=>Geolocation);
class Geolocation {
    static get() {
        return new Promise((resolve, reject)=>{
            navigator.geolocation.getCurrentPosition((position)=>resolve(position.coords), reject);
        });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2JS7q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Microphone input, unprocessed by default.
 *
 * The default matters more than it looks. Browsers enable echo cancellation,
 * noise suppression and automatic gain control unless told otherwise, because
 * the assumed use is a voice call. For anything that *measures* the signal —
 * pitch detection, chroma analysis, level metering — those are actively
 * destructive: noise suppression eats sustained tones it decides are
 * background, and AGC rewrites the amplitude you were trying to read.
 *
 * So `processing` defaults to false. Turn it on for speech.
 */ parcelHelpers.export(exports, "MicrophoneStream", ()=>MicrophoneStream);
class MicrophoneStream {
    constructor({ processing = false, deviceId } = {}){
        this.stream = null;
        this.devices = [];
        this.label = "";
        this.processing = processing;
        this.deviceId = deviceId;
    }
    async start() {
        this.stop();
        const audio = this.processing ? {} : {
            echoCancellation: false,
            noiseSuppression: false,
            autoGainControl: false
        };
        if (this.deviceId) audio.deviceId = {
            exact: this.deviceId
        };
        this.stream = await navigator.mediaDevices.getUserMedia({
            audio,
            video: false
        });
        const track = this.stream.getAudioTracks()[0];
        this.label = (track?.label || "microphone").slice(0, 28);
        return this.stream;
    }
    async refreshDevices() {
        try {
            const all = await navigator.mediaDevices.enumerateDevices();
            this.devices = all.filter((device)=>device.kind === "audioinput");
        } catch  {
            this.devices = [];
        }
        return this.devices;
    }
    stop() {
        if (!this.stream) return;
        for (const track of this.stream.getTracks())track.stop();
        this.stream = null;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4BPPy":[function(require,module,exports,__globalThis) {
// http://aaron.headwai.com/ra/MIDI/MIDI%20Message%20Table%201.pdf
// https://www.midi.org/specifications-old/item/table-2-expanded-messages-list-status-bytes
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MIDIEvent", ()=>MIDIEvent);
parcelHelpers.export(exports, "MIDI", ()=>MIDI);
class MIDIEvent {
    constructor(device, event){
        this.device = {
            id: device.id,
            type: device.type,
            name: device.name,
            connection: device.connection,
            manufacturer: device.manufacturer,
            state: device.state,
            version: device.version,
            close: device.close,
            open: device.open
        };
        if (event?.data) {
            const { channel, type, a, b } = MIDIEvent.describedValuesFromData(event.data);
            this.channel = channel;
            this.type = type;
            this.a = a;
            this.b = b;
        } else {
            this.channel = null;
            this.type = MIDIEvent.toType(device.state === "connected" ? "Device Connected" : "Device Disconnected");
            this.a = null;
            this.b = null;
        }
    }
    static toType(string) {
        if (!string) return string;
        return string.replace(/[^\w\d]/, " ").replace(/ +$/, "").replace(/ +/, "_").toLowerCase();
    }
    static describedData(data, name, label1, label2) {
        const [func, byte1, byte2] = data;
        const channel = func >= 128 && func <= 239 ? func % 16 + 1 : 0;
        const value = (val)=>typeof val === "number" ? val : null;
        const ratio = (val)=>typeof val === "number" ? val / 127 : null;
        const string = (val)=>val || null;
        return {
            channel,
            type: MIDIEvent.toType(name),
            a: {
                value: value(byte1),
                ratio: ratio(byte1),
                type: string(MIDIEvent.toType(label1 || ""))
            },
            b: {
                value: value(byte2),
                ratio: ratio(byte2),
                type: string(MIDIEvent.toType(label2 || ""))
            }
        };
    }
    static describedValuesFromData(data) {
        const [func, byte1] = data;
        if (func >= 128 && func <= 143) return MIDIEvent.describedData(data, "Note Off", "Note", "Velocity");
        else if (func >= 144 && func <= 159) return MIDIEvent.describedData(data, "Note On", "Note", "Velocity");
        else if (func >= 160 && func <= 175) return MIDIEvent.describedData(data, "Polyphonic Aftertouch", "Note", "Pressure");
        else if (func >= 176 && func <= 191) return MIDIEvent.describedData(data, "Mode Change", "Mode", MIDIEvent.modeLabel(byte1));
        else if (func >= 192 && func <= 207) return MIDIEvent.describedData(data, "Program Change", "Program");
        else if (func >= 208 && func <= 223) return MIDIEvent.describedData(data, "Aftertouch", "Pressure");
        else if (func >= 224 && func <= 239) return MIDIEvent.describedData(data, "Pitch Wheel Control", "LSB", "MSB");
        else switch(func){
            case 240:
                return MIDIEvent.describedData(data, "System Exclusive");
            case 241:
                return MIDIEvent.describedData(data, "MIDI Time Code Qtr. Frame");
            case 242:
                return MIDIEvent.describedData(data, "Song Position Pointer", "LSB", "MSB");
            case 243:
                return MIDIEvent.describedData(data, "Song Select", "Song #");
            case 244:
                return MIDIEvent.describedData(data, "Unspecified (Reserved)");
            case 245:
                return MIDIEvent.describedData(data, "Unspecified (Reserved)");
            case 246:
                return MIDIEvent.describedData(data, "Tune request'");
            case 247:
                return MIDIEvent.describedData(data, "End of SysEx (EOX)");
            case 248:
                return MIDIEvent.describedData(data, "Timing clock");
            case 249:
                return MIDIEvent.describedData(data, "Unspecified (Reserved)");
            case 250:
                return MIDIEvent.describedData(data, "Start");
            case 251:
                return MIDIEvent.describedData(data, "Continue");
            case 252:
                return MIDIEvent.describedData(data, "Stop");
            case 253:
                return MIDIEvent.describedData(data, "Unspecified (Reserved)");
            case 254:
                return MIDIEvent.describedData(data, "Active Sensing");
            case 255:
                return MIDIEvent.describedData(data, "System Reset");
        }
        return {
            channel: null,
            type: "Unknown",
            a: null,
            b: null
        };
    }
    static modeLabel(byte1) {
        return [
            "Bank Select",
            "Modulation Wheel or Lever",
            "Breath Controller",
            "Unspecified",
            "Foot Controller",
            "Portamento Time",
            "Data Entry MSB",
            "Channel Volume",
            "Balance",
            "Unspecified",
            "Pan",
            "Expression Controller",
            "Effect Control 1",
            "Effect Control 2",
            "Unspecified",
            "Unspecified",
            "General Purpose Controller 1",
            "General Purpose Controller 2",
            "General Purpose Controller 3",
            "General Purpose Controller 4",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "LSB for Control 0 (Bank Select)",
            "LSB for Control 1 (Modulation Wheel or Lever)",
            "LSB for Control 2 (Breath Controller)",
            "LSB for Control 3 (Unspecified)",
            "LSB for Control 4 (Foot Controller)",
            "LSB for Control 5 (Portamento Time)",
            "LSB for Control 6 (Data Entry)",
            "LSB for Control 7 (Channel Volume)",
            "LSB for Control 8 (Balance)",
            "LSB for Control 9 (Unspecified)",
            "LSB for Control 10 (Pan)",
            "LSB for Control 11 (Expression Controller)",
            "LSB for Control 12 (Effect control 1)",
            "LSB for Control 13 (Effect control 2)",
            "LSB for Control 14 (Unspecified)",
            "LSB for Control 15 (Unspecified)",
            "LSB for Control 16 (General Purpose Controller 1)",
            "LSB for Control 17 (General Purpose Controller 2)",
            "LSB for Control 18 (General Purpose Controller 3)",
            "LSB for Control 19 (General Purpose Controller 4)",
            "LSB for Control 20 (Unspecified)",
            "LSB for Control 21 (Unspecified)",
            "LSB for Control 22 (Unspecified)",
            "LSB for Control 23 (Unspecified)",
            "LSB for Control 24 (Unspecified)",
            "LSB for Control 25 (Unspecified)",
            "LSB for Control 26 (Unspecified)",
            "LSB for Control 27 (Unspecified)",
            "LSB for Control 28 (Unspecified)",
            "LSB for Control 29 (Unspecified)",
            "LSB for Control 30 (Unspecified)",
            "LSB for Control 31 (Unspecified)",
            "Damper Pedal on/off (Sustain) \u226463 off, \u226564 on",
            "Portamento On/Off \u226463 off, \u226564 on",
            "Sostenuto On/Off \u226463 off, \u226564 on",
            "Soft Pedal On/Off \u226463 off, \u226564 on",
            "Legato Footswitch \u226463 Normal, \u226564 Legato",
            "Hold 2 \u226463 off, \u226564 on",
            "Sound Controller 1 (default: Sound Variation)",
            "Sound Controller 2 (default: Timbre/Harmonic Intensity)",
            "Sound Controller 3 (default: Release Time)",
            "Sound Controller 4 (default: Attack Time)",
            "Sound Controller 5 (default: Brightness)",
            "Sound Controller 6 (default: Decay Time)",
            "Sound Controller 7 (default: Vibrato Rate)",
            "Sound Controller 8 (default: Vibrato Depth)",
            "Sound Controller 9 (default: Vibrato Delay)",
            "Sound Controller 10 (default: Unspecified)",
            "General Purpose Controller 5",
            "General Purpose Controller 6",
            "General Purpose Controller 7",
            "General Purpose Controller 8",
            "Portamento Control",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "High Resolution Velocity Prefix",
            "Unspecified",
            "Unspecified",
            "Effects 1 Depth",
            "Effects 2 Depth",
            "Effects 3 Depth",
            "Effects 4 Depth",
            "Effects 5 Depth",
            "Data Increment (Data Entry +1)",
            "Data Decrement (Data Entry -1)",
            "Non-Registered Parameter Number (NRPN) - LSB",
            "Non-Registered Parameter Number (NRPN) - MSB",
            "Registered Parameter Number (RPN) - LSB",
            "Registered Parameter Number (RPN) - MSB",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "Unspecified",
            "[Channel Mode Message] All Sound Off 0",
            "[Channel Mode Message] Reset All Controllers",
            "[Channel Mode Message] Local Control On/Off 0 off, 127 on",
            "[Channel Mode Message] All Notes Off 0",
            "[Channel Mode Message] Omni Mode Off (+ all notes off) 0",
            "[Channel Mode Message] Omni Mode On (+ all notes off) 0",
            "[Channel Mode Message] Mono Mode On (+ poly off, + all notes off)",
            "[Channel Mode Message] Poly Mode On (+ mono off, +all notes off)"
        ][byte1];
    }
}
class MIDI {
    constructor({ onEvent }){
        this.inputs = {};
        this.outputs = {};
        this.onEvent = onEvent;
    }
    async initialize() {
        const access = await navigator.requestMIDIAccess();
        const inputs = access.inputs.values();
        const outputs = access.outputs.values();
        for (const input of inputs)this.initializeInput(input);
        for (const output of outputs)this.initializeOutput(output);
        access.addEventListener("statechange", (event)=>{
            const { port } = event;
            if (port?.type === "input") {
                if (port.state === "connected") this.initializeInput(port);
                else this.teardownInput(port);
            } else if (port) {
                if (port.state === "connected") this.initializeOutput(port);
                else this.teardownOutput(port);
            }
        });
        return;
    }
    notifyAll(message) {
        Object.values(this.outputs).forEach((output)=>{
            if (MIDI.portIsOutput(output)) output.send(message);
        });
    }
    notify(message, name) {
        Object.values(this.outputs).forEach((output)=>{
            if (MIDI.portIsOutput(output) && (output.name === name || !name)) // console.log(
            //   "sending",
            //   name,
            //   output,
            //   MIDIEvent.describedValuesFromData(message)
            // );
            output.send(message);
        });
    }
    initializeInput(input) {
        if (this.inputs[input.id]) return;
        this.sendEvent(input);
        this.inputs[input.id] = input;
        input.addEventListener("midimessage", (event)=>{
            this.sendEvent(input, event);
        });
    }
    initializeOutput(output) {
        this.sendEvent(output);
        this.outputs[output.id] = output;
    }
    teardownInput(input) {
        if (!this.inputs[input.id]) return;
        this.sendEvent(input);
        delete this.inputs[input.id];
    }
    teardownOutput(output) {
        if (!this.outputs[output.id]) return;
        this.sendEvent(output);
        delete this.outputs[output.id];
    }
    sendEvent(port, event) {
        if (event) this.onEvent(new MIDIEvent(port, event));
    }
    static portIsInput(port) {
        return port.type === "input";
    }
    static portIsOutput(port) {
        return port.type === "output";
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1cdOU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A screen, window or tab capture.
 *
 * Separate from CameraStream because it behaves differently in the one way
 * that matters: the user can end it from browser chrome at any time, without
 * touching your UI. Anything relying on the stream has to hear about that, so
 * `onEnded` is part of the API rather than an afterthought — without it the
 * app sits on a dead stream showing a frozen last frame.
 */ parcelHelpers.export(exports, "ScreenStream", ()=>ScreenStream);
class ScreenStream {
    constructor({ displaySurface = "browser", audio = false } = {}){
        this.stream = null;
        this.label = "";
        /** Called when the user stops sharing from browser chrome. */ this.onEnded = null;
        this.displaySurface = displaySurface;
        this.audio = audio;
    }
    /** Opens the browser's picker. Must be called from a user gesture. */ async start() {
        this.stop();
        this.stream = await navigator.mediaDevices.getDisplayMedia({
            video: {
                displaySurface: this.displaySurface
            },
            audio: this.audio
        });
        const track = this.stream.getVideoTracks()[0];
        this.label = (track?.label || "screen").slice(0, 28);
        // `once` because a track only ends once, and the stream is discarded here
        // so a stale listener would otherwise outlive what it refers to.
        track?.addEventListener("ended", ()=>{
            this.stream = null;
            this.onEnded?.();
        }, {
            once: true
        });
        return this.stream;
    }
    stop() {
        if (!this.stream) return;
        for (const track of this.stream.getTracks())track.stop();
        this.stream = null;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hxdzl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserMediaStream", ()=>UserMediaStream);
class UserMediaStream {
    constructor(){
        this.devices = [];
    }
    async start(constraints) {
        this.stream = await navigator.mediaDevices.getUserMedia(constraints);
        await this.refreshDevices();
        return this.stream;
    }
    async refreshDevices() {
        this.devices = await navigator.mediaDevices.enumerateDevices();
    }
    get audioInputDevices() {
        return this.devices.filter((device)=>device.kind === "audioinput");
    }
    get videoInputDevices() {
        return this.devices.filter((device)=>device.kind === "videoinput");
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},[], null, "parcelRequire4648", {})

//# sourceMappingURL=cosmos.f780cf76.js.map
